import React, { useState } from 'react';
import { Stack, Typography, Button } from "@mui/material";
import { UseIsTruncated } from "./useIsTruncated";

export default function ExpandableTextCell({ text }) {
  const [expanded, setExpanded] = React.useState(false);
  const [ref, isTruncated] = UseIsTruncated();

  if (!text || typeof text !== "string" || text.trim().length === 0) {
    return (
      <Typography variant="body2" color="text.secondary">
        —
      </Typography>
    );
  }

  return (
    <Stack spacing={0.5}>
      <Typography
        ref={ref}
        variant="body2"
        sx={{
          whiteSpace: "pre-wrap",
          wordBreak: "break-word",
          display: "-webkit-box",
          WebkitBoxOrient: "vertical",
          overflow: "hidden",
          WebkitLineClamp: expanded ? "unset" : 4,
        }}
      >
        {text}
      </Typography>

      {isTruncated && (
        <Button
          size="small"
          variant="text"
          sx={{ alignSelf: "flex-start", px: 0 }}
          onClick={() => setExpanded((x) => !x)}
        >
          {expanded ? "Скрыть" : "Подробнее"}
        </Button>
      )}
    </Stack>
  );
}
